// import React, { useEffect, useMemo, useState } from "react";
// import { Row, Col } from "react-bootstrap";
// import { Sidebar } from "primereact/sidebar";
// import { Button } from "primereact/button";
// import { InputSwitch } from "primereact/inputswitch";
// import {
//   ConfirmDialog,
//   confirmDialog,
// } from "primereact/confirmdialog";
// import { ProgressBar } from "primereact/progressbar";
// import { Dialog } from "primereact/dialog";
// import {
//   Inplace,
//   InplaceDisplay,
//   InplaceContent,
// } from "primereact/inplace";
// import { PiCoinsDuotone } from "react-icons/pi";
// import { useNavigate } from "react-router-dom";
// import moment from "moment";

// import Renew from "../../components/Renew";
// import { useAuth } from "../../context/AuthContext";
// import api from "../../api/axios";

// const TERMINAL_STATUSES = [
//   "CANCELLED",
//   "COMPLETED",
//   "EXPIRED",
// ];



// const getStatusTheme = (
//   status,
//   cancellationScheduled = false
// ) => {
//   if (cancellationScheduled) {
//     return {
//       backgroundColor: "#7A5512",
//       border: "1px solid #FFBF00",
//       color: "#FFFFFF",
//     };
//   }

//   switch (status) {
//     case "ACTIVE":
//       return {
//         backgroundColor: "#1D6B55",
//         border: "1px solid #17E1A8",
//         color: "#FFFFFF",
//       };

//     case "PENDING":
//       return {
//         backgroundColor: "#7A5512",
//         border: "1px solid #FFBF00",
//         color: "#FFFFFF",
//       };

//     case "HALTED":
//       return {
//         backgroundColor: "#8A275B",
//         border: "1px solid #FF71BC",
//         color: "#FFFFFF",
//       };

//     case "CANCELLED":
//       return {
//         backgroundColor: "#8C1C31",
//         border: "1px solid #E72448",
//         color: "#FFFFFF",
//       };

//     case "COMPLETED":
//       return {
//         backgroundColor: "#1D6B55",
//         border: "1px solid #17E1A8",
//         color: "#FFFFFF",
//       };

//     case "EXPIRED":
//       return {
//         backgroundColor: "#444444",
//         border: "1px solid #777777",
//         color: "#FFFFFF",
//       };

//     default:
//       return {
//         backgroundColor: "#2D2C2C",
//         border: "1px solid #555555",
//         color: "#FFFFFF",
//       };
//   }
// };

// const Subscriptions = () => {
//   const { balance, creditlimit } = useAuth();
//   const navigate = useNavigate();

//   const [visibleRight, setVisibleRight] =
//     useState(false);

//   const [subscription, setSubscription] =
//     useState(null);

//   const [loading, setLoading] =
//     useState(true);

//   const [renewData, setRenewData] =
//     useState(null);

//   const [checked, setChecked] =
//     useState(false);

//   const [
//     cancelDialogVisible,
//     setCancelDialogVisible,
//   ] = useState(false);

//   const [cancelLoading, setCancelLoading] =
//     useState(false);

//   const [refundLoading, setRefundLoading] =
//     useState(false);

//   const [actionError, setActionError] =
//     useState("");

//   /*
//    * Values returned by:
//    *
//    * GET /customerProfileRoutes/customer/subscription
//    */
//   const refundEligibility =
//     subscription?.refund_eligibility || null;

//   const cancellationScheduled =
//     subscription?.cancellation?.scheduled === true;

//   /*
//    * Prefer the explicit backend actions.
//    *
//    * Fallback logic is included so the page remains
//    * usable while the backend response is being updated.
//    */
//   const canCancelSubscription =
//     subscription?.actions?.can_cancel != null
//       ? subscription.actions.can_cancel === true
//       : Boolean(subscription) &&
//         !cancellationScheduled &&
//         !TERMINAL_STATUSES.includes(
//           subscription?.status
//         );

//   const canSwitchPlan =
//     subscription?.actions?.can_switch_plan != null
//       ? subscription.actions.can_switch_plan === true
//       : subscription?.status === "ACTIVE" &&
//         !cancellationScheduled;

//   const showRefundButton =
//     !cancellationScheduled &&
//     !TERMINAL_STATUSES.includes(
//       subscription?.status
//     ) &&
//     (
//       subscription?.actions
//         ?.show_refund_button === true ||
//       refundEligibility?.eligible === true ||
//       refundEligibility
//         ?.show_refund_button === true
//     );

//   const refundDeadline =
//     refundEligibility?.refund_deadline ||
//     refundEligibility?.subscription
//       ?.refund_deadline ||
//     null;

//   const refundCredits =
//     refundEligibility?.credits || {};

//   const statusLabel =
//     cancellationScheduled
//       ? "CANCELLATION SCHEDULED"
//       : subscription?.status;

//   const statusTheme = getStatusTheme(
//     subscription?.status,
//     cancellationScheduled
//   );

//   const billingDateLabel =
//     cancellationScheduled
//       ? "Access until"
//       : subscription?.auto_renew
//         ? "Next payment"
//         : "Current period ends";

//   const billingDate =
//     cancellationScheduled
//       ? subscription?.cancellation
//           ?.access_until ||
//         subscription?.end_date
//       : subscription?.auto_renew
//         ? subscription?.renewal_date
//         : subscription?.end_date;

//   const autoRenewText =
//     cancellationScheduled
//       ? "Cancellation Scheduled"
//       : checked
//         ? "Auto Renew On"
//         : "Auto Renew Off";

//   const percentage = useMemo(() => {
//     const currentBalance =
//       Number(balance || 0);

//     const maximumCredits =
//       Number(creditlimit || 0);

//     if (maximumCredits <= 0) {
//       return 0;
//     }

//     return Math.min(
//       Math.max(
//         (currentBalance /
//           maximumCredits) *
//           100,
//         0
//       ),
//       100
//     );
//   }, [balance, creditlimit]);

//   const fetchSubscription = async () => {
//     try {
//       setLoading(true);
//       setActionError("");

//       const response = await api.get(
//         "/customerProfileRoutes/customer/subscription"
//       );

//       if (response.data?.success) {
//         const subscriptionData =
//           response.data.data || null;

//         setSubscription(subscriptionData);

//         setChecked(
//           Boolean(
//             subscriptionData?.auto_renew
//           )
//         );
//       }
//     } catch (error) {
//       console.error(
//         "Failed to fetch subscription:",
//         error.response?.data || error
//       );

//       setSubscription(null);
//       setChecked(false);

//       setActionError(
//         error.response?.data?.message ||
//           "Failed to load subscription details."
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchSubscription();
//   }, []);

//   /*
//    * Normal cancellation:
//    *
//    * cancelImmediately = true
//    * => immediate cancellation without refund.
//    *
//    * cancelImmediately = false
//    * => cancellation at billing-cycle end.
//    */
//   const handleCancelSubscription = async (
//     cancelImmediately
//   ) => {
//     if (
//       !subscription
//         ?.customer_subscription_id
//     ) {
//       return;
//     }

//     try {
//       setCancelLoading(true);
//       setActionError("");

//       const response = await api.post(
//         `/paymentrzrrts/subscriptions/${subscription.customer_subscription_id}/cancel`,
//         {
//           cancel_at_cycle_end:
//             !cancelImmediately,
//         }
//       );

//       if (response.data?.success) {
//         setCancelDialogVisible(false);

//         await fetchSubscription();
//       }
//     } catch (error) {
//       console.error(
//         "Subscription cancellation failed:",
//         error.response?.data || error
//       );

//       setActionError(
//         error.response?.data?.message ||
//           "Failed to cancel the subscription."
//       );
//     } finally {
//       setCancelLoading(false);
//     }
//   };

//   /*
//    * Refund cancellation:
//    *
//    * Eligibility is displayed using the main
//    * subscription response.
//    *
//    * The backend endpoint must still validate
//    * eligibility again before processing.
//    */
//   const handleCancelAndRefund = async () => {
//     if (
//       !subscription
//         ?.customer_subscription_id ||
//       !showRefundButton
//     ) {
//       return;
//     }

//     try {
//       setRefundLoading(true);
//       setActionError("");

//       const response = await api.post(
//         `/Subrefund/subscriptions/${subscription.customer_subscription_id}/cancel-and-refund`
//       );

//       if (response.data?.success) {
//         /*
//          * Full reload refreshes:
//          * - subscription state
//          * - AuthContext wallet balance
//          * - credit counters
//          */
//         window.location.reload();
//       }
//     } catch (error) {
//       console.error(
//         "Cancel and refund failed:",
//         error.response?.data || error
//       );

//       setActionError(
//         error.response?.data?.message ||
//           "Failed to cancel the subscription and initiate the refund."
//       );

//       /*
//        * Eligibility may have changed between
//        * loading the page and clicking the button.
//        */
//       await fetchSubscription();
//     } finally {
//       setRefundLoading(false);
//     }
//   };

//   const confirmCancelAndRefund = () => {
//     confirmDialog({
//       header:
//         "Cancel Subscription and Get Refund",

//       message:
//         "Your subscription will end immediately, your wallet balance will be reset to zero, and the eligible payment will be refunded. This action cannot be undone.",

//       //icon:
//         //"pi pi-exclamation-triangle",

//       acceptLabel:
//         "Cancel & Refund",

//       rejectLabel:
//         "Keep Subscription",

//       acceptClassName:
//         "p-button-danger",

//       className: "cancel-dialog",

//       accept:
//         handleCancelAndRefund,
//     });
//   };

//   const openCancellationDialog = () => {
//     if (!canCancelSubscription) {
//       return;
//     }

//     setActionError("");
//     setCancelDialogVisible(true);
//   };

//   const closeCancellationDialog = () => {
//     if (
//       cancelLoading ||
//       refundLoading
//     ) {
//       return;
//     }

//     setCancelDialogVisible(false);
//   };

//   const renderStatusMessage = () => {
//     if (cancellationScheduled) {
//       return (
//         <>
//           <strong>
//             Cancellation scheduled
//           </strong>

//           <br />

//           Your subscription remains active
//           until{" "}

//           <strong>
//             {moment(
//               subscription?.cancellation
//                 ?.access_until ||
//                 subscription?.end_date
//             ).format("DD MMM YYYY")}
//           </strong>
//           .

//           <br />

//           You will not be charged again.
//         </>
//       );
//     }

//     switch (subscription?.status) {
//       case "ACTIVE":
//         return (
//           <>
//             Your subscription is currently
//             active.
//           </>
//         );

//       case "PENDING":
//         return (
//           <>
//             ⚠️ Payment update required. Your
//             last auto-debit attempt failed.

//             <br />

//             Please update your payment method
//             to avoid service interruption.
//           </>
//         );

//       case "HALTED":
//         return (
//           <>
//             ❌ Your subscription has been
//             halted due to failed payment
//             retries.

//             <br />

//             Please renew your subscription to
//             restore access.
//           </>
//         );

//       case "CANCELLED":
//         return (
//           <>
//             🚫 Your subscription has been
//             cancelled.
//           </>
//         );

//       case "COMPLETED":
//         return (
//           <>
//             🎉 Your subscription cycle has
//             been completed successfully.

//             <br />

//             Buy again to renew your
//             subscription.
//           </>
//         );

//       case "EXPIRED":
//         return (
//           <>
//             Your subscription has expired.
//           </>
//         );

//       default:
//         return null;
//     }
//   };

//   return (
//     <>
//       <ConfirmDialog className="alartDig" />

//       <Row className="mx-0">
//         <Col
//           md={12}
//           lg={12}
//           xs={12}
//           className="prof_title p-0 mb-lg-4 d-lg-flex justify-content-between align-items-center"
//         >
//           <h4>Subscriptions</h4>

//           <div className="d-flex gap-2">
//             <div className="d-lg-flex align-items-center gap-2">
//               <p className="text-pink mb-0">
//                 {autoRenewText}
//               </p>

//               <InputSwitch
//                 checked={checked}
//                 disabled
//               />
//             </div>

//             {subscription &&
//               !cancellationScheduled &&
//               (
//                 subscription.status ===
//                   "PENDING" ||
//                 subscription.status ===
//                   "HALTED"
//               ) && (
//                 <Button
//                   className="py-1 custbuttonpink"
//                   label="Renew Now"
//                   outlined
//                   onClick={() => {
//                     setRenewData(subscription);
//                     setVisibleRight(true);
//                   }}
//                 />
//               )}
//           </div>
//         </Col>

//         <Row className="mx-0 justify-content-between">
//           <Col
//             md={12}
//             lg={5}
//             xs={12}
//             className="mt-4 packCard bg-transparent px-0"
//           >
//             <div className="leftsubs">
//               <h4 className="mb-3">
//                 Plan

//                 {statusLabel && (
//                   <span
//                     className="ms-2 px-2 py-1"
//                     style={{
//                       fontSize: "9px",
//                       borderRadius: "20px",
//                       fontWeight: 400,
//                       fontFamily:
//                         "SFPro, serif",
//                       letterSpacing:
//                         "0.5px",
//                       ...statusTheme,
//                     }}
//                   >
//                     {statusLabel}
//                   </span>
//                 )}
//               </h4>

//               {loading && (
//                 <p className="text-secondary">
//                   Loading subscription...
//                 </p>
//               )}

//               {!subscription &&
//                 !loading && (
//                   <p className="text-secondary">
//                     No subscription found
//                   </p>
//                 )}

//               {subscription && (
//                 <>
//                   <p>
//                     <span>
//                       {
//                         subscription
//                           ?.subscription
//                           ?.sub_name
//                       }{" "}
//                       –{" "}
//                       {
//                         subscription
//                           ?.subscription
//                           ?.price
//                       }{" "}
//                       INR /{" "}

//                       {subscription
//                         ?.subscription
//                         ?.plan_type
//                         ?.toLowerCase()}

//                       <br />

//                       <small>
//                         VAT or sales tax may
//                         apply
//                       </small>
//                     </span>
//                   </p>

//                   <p>
//                     <b>
//                       Plan Type:{" "}

//                       {subscription
//                         ?.subscription
//                         ?.plan_type
//                         ?.toLowerCase()}
//                     </b>

//                     {billingDate && (
//                       <span className="d-block">
//                         {billingDateLabel}:{" "}

//                         <small className="text-pink">
//                           {moment(
//                             billingDate
//                           ).format(
//                             "DD MMM YYYY"
//                           )}
//                         </small>
//                       </span>
//                     )}
//                   </p>
//                 </>
//               )}
//             </div>

//             <div>
//               {subscription?.status && (
//                 <div
//                   className="mb-3 resp_subs"
//                   style={{
//                     fontWeight: 400,
//                     fontFamily:
//                       "SFPro, serif",
//                     letterSpacing:
//                       "0.5px",
//                     width: "fit-content",
//                     maxWidth: "100%",
//                     borderRadius: "20px",
//                     padding: "12px 15px",
//                     ...statusTheme,
//                   }}
//                 >
//                   {renderStatusMessage()}
//                 </div>
//               )}

//               {showRefundButton && (
//                 <div
//                   className="mb-3"
//                   style={{
//                     width: "100%",
//                     maxWidth: "520px",
//                     padding: "15px",
//                     borderRadius: "12px",
//                     background:
//                       "rgba(29, 107, 85, 0.18)",
//                     border:
//                       "1px solid #17E1A8",
//                     color: "#FFFFFF",
//                   }}
//                 >
//                   <h5 className="mb-2">
//                     Eligible for a refund
//                   </h5>

//                   <p
//                     className="mb-2"
//                     style={{
//                       fontSize: "13px",
//                     }}
//                   >
//                     You are within the first
//                     15 days of the subscription
//                     and at least 50% of your
//                     subscription credits
//                     remain.
//                   </p>

//                   {refundDeadline && (
//                     <small
//                       className="d-block mb-2"
//                       style={{
//                         color: "#C5C5C5",
//                       }}
//                     >
//                       Refund eligibility ends
//                       on{" "}

//                       <span className="text-pink">
//                         {moment(
//                           refundDeadline
//                         ).format(
//                           "DD MMM YYYY, hh:mm A"
//                         )}
//                       </span>
//                       .
//                     </small>
//                   )}

//                   {refundCredits
//                     ?.plan_credits != null && (
//                     <small
//                       className="d-block mb-3"
//                       style={{
//                         color: "#C5C5C5",
//                       }}
//                     >
//                       Wallet balance:{" "}

//                       <span className="text-white">
//                         {
//                           refundCredits
//                             .wallet_balance
//                         }
//                       </span>

//                       {" / "}

//                       Plan credits:{" "}

//                       <span className="text-white">
//                         {
//                           refundCredits
//                             .plan_credits
//                         }
//                       </span>
//                     </small>
//                   )}

//                   <Button
//                     label="Cancel Now & Get Refund"
//                     severity="danger"
//                     loading={refundLoading}
//                     disabled={
//                       refundLoading ||
//                       cancelLoading
//                     }
//                     onClick={
//                       confirmCancelAndRefund
//                     }
//                   />
//                 </div>
//               )}

//               {actionError && (
//                 <div
//                   className="mb-3"
//                   style={{
//                     width: "100%",
//                     maxWidth: "520px",
//                     padding: "10px 12px",
//                     borderRadius: "8px",
//                     color: "#FFDAE1",
//                     background:
//                       "rgba(231, 36, 72, 0.15)",
//                     border:
//                       "1px solid #E72448",
//                     fontSize: "13px",
//                   }}
//                 >
//                   {actionError}
//                 </div>
//               )}
//             </div>
//           </Col>

//           <Col
//             md={12}
//             lg={6}
//             xs={12}
//             className="mt-4 packCard bg-transparent px-0"
//           >
//             <div className="rightsubs">
//               <h4 className="mb-3">
//                 Credit
//               </h4>

//               {!subscription &&
//                 !loading && (
//                   <p className="text-secondary">
//                     No credits available
//                   </p>
//                 )}

//               {subscription && (
//                 <div
//                   style={{
//                     width: "100%",
//                     maxWidth: "420px",
//                   }}
//                 >
//                   <ProgressBar
//                     value={percentage}
//                     showValue={false}
//                     style={{
//                       height: "6px",
//                       borderRadius: "10px",
//                       background:
//                         "#2D2C2C",
//                     }}
//                   />

//                   <div className="flex justify-content-between mt-3 mb-2 text-sm">
//                     <span className="text-white">
//                       Balance

//                       <small
//                         style={{
//                           color: "#C5C5C5",
//                           fontSize: "13px",
//                           fontWeight: 400,
//                           letterSpacing:
//                             "0.5px",
//                           marginLeft: "8px",
//                           borderRadius:
//                             "13px",
//                           border:
//                             "1px dashed #7C7C7C",
//                           background: "#111111",
//                           padding: "3px 8px",
//                         }}
//                       >
//                         <PiCoinsDuotone className="text-pink" />{" "}

//                         {balance}
//                       </small>
//                     </span>
//                   </div>

//                   <small
//                     style={{
//                       display: "block",
//                       fontSize: "12px",
//                       color: "#C5C5C5",
//                       margin:
//                         "6px 0 15px 0",
//                       letterSpacing:
//                         "0.65px",
//                     }}
//                   >
//                     {
//                       subscription
//                         ?.subscription
//                         ?.credits_per_month
//                     }{" "}
//                     credits added{" "}

//                     {subscription
//                       ?.subscription
//                       ?.plan_type
//                       ?.toLowerCase()}
//                   </small>
//                 </div>
//               )}
//             </div>

//             <div className="dangerzonePart">
//               {canCancelSubscription && (
//                 <Inplace closable>
//                   <InplaceDisplay className="buttonpart">
//                     Cancel a subscription
//                   </InplaceDisplay>

//                   <InplaceContent className="dengerAcordian">
//                     <p className="m-0">
//                       You can cancel your
//                       subscription immediately
//                       or schedule cancellation
//                       for the end of the current
//                       billing period.
//                     </p>

//                     <hr />

//                     <p className="m-0">
//                       Your active subscription:
//                     </p>

//                     <div className="mt-3">
//                       <div>
//                         <h4 className="mb-0">
//                           {
//                             subscription
//                               ?.subscription
//                               ?.sub_name
//                           }{" "}
//                           –{" "}

//                           <span className="text-pink">
//                             {
//                               subscription
//                                 ?.subscription
//                                 ?.price
//                             }{" "}
//                             INR /{" "}

//                             {subscription
//                               ?.subscription
//                               ?.plan_type
//                               ?.toLowerCase()}
//                           </span>
//                         </h4>

//                         <p
//                           className="mb-0 text-white"
//                           style={{
//                             fontSize: "15px",
//                             marginTop: "8px",
//                           }}
//                         >
//                           Next payment:{" "}

//                           <span className="text-pink">
//                             {moment(
//                               subscription
//                                 ?.renewal_date
//                             ).format(
//                               "MMM Do, YYYY"
//                             )}
//                           </span>
//                         </p>
//                       </div>

//                       <div className="d-flex gap-2 justify-content-end mt-5">
//                         {canSwitchPlan && (
//                           <Button
//                             label="Switch plan"
//                             className="switchplan"
//                             onClick={() =>
//                               navigate(
//                                 "/planupdate"
//                               )
//                             }
//                           />
//                         )}

//                         <Button
//                           label="Cancel subscription"
//                           className="cancelplan"
//                           onClick={
//                             openCancellationDialog
//                           }
//                         />
//                       </div>
//                     </div>
//                   </InplaceContent>
//                 </Inplace>
//               )}

//               {cancellationScheduled && (
//                 <div className="dengerAcordian">
//                   <h5 className="mb-2">
//                     Cancellation already
//                     scheduled
//                   </h5>

//                   <p className="mb-0 text-secondary">
//                     Your subscription will end
//                     on{" "}

//                     <span className="text-pink">
//                       {moment(
//                         subscription
//                           ?.cancellation
//                           ?.access_until ||
//                           subscription?.end_date
//                       ).format(
//                         "DD MMM YYYY"
//                       )}
//                     </span>
//                     . You will not be charged
//                     again and no further
//                     cancellation action is
//                     required.
//                   </p>
//                 </div>
//               )}

//               {subscription &&
//                 TERMINAL_STATUSES.includes(
//                   subscription.status
//                 ) && (
//                   <div className="subEnddiv">
//                     <h5 className="mb-2">
//                       Subscription ended
//                     </h5>

//                     <p className="mb-0 text-secondary">
//                       This subscription cannot
//                       be cancelled again.
//                     </p>
//                      <small className="mb-0 mt-2 text-danger">
//                       **If it is a refund then it will be processed in 5-7 days.
//                     </small>
//                   </div>
//                 )}
//             </div>
//           </Col>
//         </Row>
//       </Row>

//       <Sidebar
//         className="shortCartSide"
//         visible={visibleRight}
//         position="right"
//         onHide={() =>
//           setVisibleRight(false)
//         }
//         style={{
//           width: "500px",
//         }}
//       >
//         <Renew
//           data={renewData}
//           onClose={() =>
//             setVisibleRight(false)
//           }
//         />
//       </Sidebar>

//       <Dialog
//         visible={cancelDialogVisible}
//         style={{
//           width: "430px",
//           textAlign: "center",
//         }}
//         onHide={
//           closeCancellationDialog
//         }
//         closable={
//           !cancelLoading &&
//           !refundLoading
//         }
//         dismissableMask={
//           !cancelLoading &&
//           !refundLoading
//         }
//         header={
//           <div
//             style={{
//               textAlign: "center",
//               color: "#d4d4d4",
//               paddingTop: "10px",
//             }}
//           >
//             Cancel Subscription
//           </div>
//         }
//       >
//         <p
//           style={{
//             fontSize: "14px",
//             textAlign: "center",
//             color: "#d4d4d4",
//           }}
//         >
//           Choose how you want to cancel your
//           subscription.
//         </p>

//         {actionError && (
//           <div
//             className="mb-3"
//             style={{
//               padding: "10px 12px",
//               borderRadius: "8px",
//               background:
//                 "rgba(231, 36, 72, 0.15)",
//               border:
//                 "1px solid #E72448",
//               color: "#FFDAE1",
//               fontSize: "13px",
//             }}
//           >
//             {actionError}
//           </div>
//         )}

//         <div className="d-flex flex-column gap-3 mt-3">
//           <Button
//             label={
//               showRefundButton
//                 ? "Cancel Immediately Without Refund"
//                 : "Cancel Immediately"
//             }
//             severity="danger"
//             outlined={
//               showRefundButton
//             }
//             loading={cancelLoading}
//             disabled={refundLoading}
//             onClick={() =>
//               handleCancelSubscription(true)
//             }
//           />

//           <Button
//             label="Cancel at End of Billing Cycle"
//             severity="warning"
//             outlined
//             loading={cancelLoading}
//             disabled={refundLoading}
//             onClick={() =>
//               handleCancelSubscription(false)
//             }
//           />
//         </div>

//         <p
//           className="mt-3"
//           style={{
//             fontSize: "12px",
//             textAlign: "center",
//             color: "#d4d4d4",
//           }}
//         >
//           <em>
//             Immediate cancellation stops access
//             instantly. End-of-cycle cancellation
//             allows usage until{" "}

//             <b>
//               {moment(
//                 subscription?.end_date ||
//                   subscription?.renewal_date
//               ).format("DD MMM YYYY")}
//             </b>
//             .
//           </em>
//         </p>
//       </Dialog>
//     </>
//   );
// };

// export default Subscriptions;



import React, {
  useEffect,
  useMemo,
  useState,
} from "react";
import {
  Row,
  Col,
} from "react-bootstrap";
import { Sidebar } from "primereact/sidebar";
import { Button } from "primereact/button";
import { InputSwitch } from "primereact/inputswitch";
// REFUND LOGIC TEMPORARILY DISABLED
// import {
//   ConfirmDialog,
//   confirmDialog,
// } from "primereact/confirmdialog";
import { ProgressBar } from "primereact/progressbar";
import { Dialog } from "primereact/dialog";
import {
  Inplace,
  InplaceDisplay,
  InplaceContent,
} from "primereact/inplace";
import { PiCoinsDuotone } from "react-icons/pi";
import { useNavigate } from "react-router-dom";
import moment from "moment";

import Renew from "../../components/Renew";
import { useAuth } from "../../context/AuthContext";
import api from "../../api/axios";

const TERMINAL_STATUSES = [
  "CANCELLED",
  "COMPLETED",
  "EXPIRED",
];

const toFiniteAmount = (
  value,
  fallback = 0
) => {
  if (
    value === null ||
    value === undefined ||
    value === ""
  ) {
    return fallback;
  }

  const amount = Number(value);

  return Number.isFinite(amount)
    ? amount
    : fallback;
};

const formatInr = (value) => {
  const amount = toFiniteAmount(
    value,
    0
  );

  return new Intl.NumberFormat(
    "en-IN",
    {
      style: "currency",
      currency: "INR",
      minimumFractionDigits:
        Number.isInteger(amount)
          ? 0
          : 2,
      maximumFractionDigits: 2,
    }
  ).format(amount);
};

const getStatusTheme = (
  status,
  cancellationScheduled = false
) => {
  if (cancellationScheduled) {
    return {
      backgroundColor: "#7A5512",
      border:
        "1px solid #FFBF00",
      color: "#FFFFFF",
    };
  }

  switch (status) {
    case "ACTIVE":
      return {
        backgroundColor: "#1D6B55",
        border:
          "1px solid #17E1A8",
        color: "#FFFFFF",
      };

    case "PENDING":
      return {
        backgroundColor: "#7A5512",
        border:
          "1px solid #FFBF00",
        color: "#FFFFFF",
      };

    case "HALTED":
      return {
        backgroundColor: "#8A275B",
        border:
          "1px solid #FF71BC",
        color: "#FFFFFF",
      };

    case "CANCELLED":
      return {
        backgroundColor: "#8C1C31",
        border:
          "1px solid #E72448",
        color: "#FFFFFF",
      };

    case "COMPLETED":
      return {
        backgroundColor: "#1D6B55",
        border:
          "1px solid #17E1A8",
        color: "#FFFFFF",
      };

    case "EXPIRED":
      return {
        backgroundColor: "#444444",
        border:
          "1px solid #777777",
        color: "#FFFFFF",
      };

    default:
      return {
        backgroundColor: "#2D2C2C",
        border:
          "1px solid #555555",
        color: "#FFFFFF",
      };
  }
};

const Subscriptions = () => {
  const {
    balance,
    creditlimit,
  } = useAuth();

  const navigate =
    useNavigate();

  const [
    visibleRight,
    setVisibleRight,
  ] = useState(false);

  const [
    subscription,
    setSubscription,
  ] = useState(null);

  const [
    loading,
    setLoading,
  ] = useState(true);

  const [
    renewData,
    setRenewData,
  ] = useState(null);

  const [
    checked,
    setChecked,
  ] = useState(false);

  const [
    cancelDialogVisible,
    setCancelDialogVisible,
  ] = useState(false);

  const [
    cancelLoading,
    setCancelLoading,
  ] = useState(false);

  // REFUND LOGIC TEMPORARILY DISABLED
  // const [
  //   refundLoading,
  //   setRefundLoading,
  // ] = useState(false);

  const [
    actionError,
    setActionError,
  ] = useState("");

  // REFUND LOGIC TEMPORARILY DISABLED
  // const refundEligibility =
  //   subscription
  //     ?.refund_eligibility ||
  //   null;

  /*
   * Resolve the actual recurring amount
   * assigned to this customer.
   *
   * Priority:
   * 1. pricing.displayed_price
   * 2. pricing.recurring_price
   * 3. subscription.recurring_price
   * 4. subscription.price
   */
  const pricing =
    subscription?.pricing || {};

  const plan =
    subscription
      ?.subscription || {};

  const displayedAmount =
    toFiniteAmount(
      pricing.displayed_price ??
        pricing.recurring_price ??
        plan.recurring_price ??
        plan.price,
      0
    );

  const regularAmount =
    toFiniteAmount(
      pricing.regular_price ??
        plan.regular_price ??
        plan.price,
      displayedAmount
    );

  const isWaitlistOffer =
    Boolean(
      pricing.is_waitlist_offer ??
        plan.is_waitlist_offer
    );

  const hasOfferDiscount =
    isWaitlistOffer &&
    regularAmount >
      displayedAmount;

  const formattedDisplayedAmount =
    formatInr(
      displayedAmount
    );

  const formattedRegularAmount =
    formatInr(
      regularAmount
    );

  const cancellationScheduled =
    subscription
      ?.cancellation
      ?.scheduled === true;

  const canCancelSubscription =
    subscription
      ?.actions
      ?.can_cancel != null
      ? subscription.actions
          .can_cancel === true
      : Boolean(subscription) &&
        !cancellationScheduled &&
        !TERMINAL_STATUSES.includes(
          subscription?.status
        );

  const canSwitchPlan =
    subscription
      ?.actions
      ?.can_switch_plan != null
      ? subscription.actions
          .can_switch_plan ===
        true
      : subscription?.status ===
          "ACTIVE" &&
        !cancellationScheduled;

  // ============================================================
  // REFUND LOGIC TEMPORARILY DISABLED
  // ============================================================
  //
  // const showRefundButton =
  //   !cancellationScheduled &&
  //   !TERMINAL_STATUSES.includes(
  //     subscription?.status
  //   ) &&
  //   (
  //     subscription
  //       ?.actions
  //       ?.show_refund_button ===
  //       true ||
  //     refundEligibility
  //       ?.eligible === true ||
  //     refundEligibility
  //       ?.show_refund_button ===
  //       true
  //   );
  //
  // const refundDeadline =
  //   refundEligibility
  //     ?.refund_deadline ||
  //   refundEligibility
  //     ?.subscription
  //     ?.refund_deadline ||
  //   null;
  //
  // const refundCredits =
  //   refundEligibility
  //     ?.credits || {};

  const statusLabel =
    cancellationScheduled
      ? "CANCELLATION SCHEDULED"
      : subscription?.status;

  const statusTheme =
    getStatusTheme(
      subscription?.status,
      cancellationScheduled
    );

  const billingDateLabel =
    cancellationScheduled
      ? "Access until"
      : subscription?.auto_renew
        ? "Next payment"
        : "Current period ends";

  const billingDate =
    cancellationScheduled
      ? subscription
          ?.cancellation
          ?.access_until ||
        subscription?.end_date
      : subscription?.auto_renew
        ? subscription
            ?.renewal_date
        : subscription?.end_date;

  const autoRenewText =
    cancellationScheduled
      ? "Cancellation Scheduled"
      : checked
        ? "Auto Renew On"
        : "Auto Renew Off";

  const percentage =
    useMemo(() => {
      const currentBalance =
        Number(
          balance || 0
        );

      const maximumCredits =
        Number(
          creditlimit || 0
        );

      if (
        maximumCredits <= 0
      ) {
        return 0;
      }

      return Math.min(
        Math.max(
          (
            currentBalance /
            maximumCredits
          ) * 100,
          0
        ),
        100
      );
    }, [
      balance,
      creditlimit,
    ]);

  const fetchSubscription =
    async () => {
      try {
        setLoading(true);
        setActionError("");

        const response =
          await api.get(
            "/customerProfileRoutes/customer/subscription"
          );

        if (
          response.data
            ?.success
        ) {
          const data =
            response.data
              .data || null;

          setSubscription(
            data
          );

          setChecked(
            Boolean(
              data?.auto_renew
            )
          );
        }
      } catch (error) {
        console.error(
          "Failed to fetch subscription:",
          error.response
            ?.data ||
            error
        );

        setSubscription(
          null
        );

        setChecked(
          false
        );

        setActionError(
          error.response
            ?.data
            ?.message ||
            "Failed to load subscription details."
        );
      } finally {
        setLoading(
          false
        );
      }
    };

  useEffect(() => {
    fetchSubscription();
  }, []);

  const handleCancelSubscription =
    async (
      cancelImmediately
    ) => {
      const customerSubscriptionId =
        subscription
          ?.customer_subscription_id;

      if (
        !customerSubscriptionId
      ) {
        return;
      }

      try {
        setCancelLoading(
          true
        );

        setActionError(
          ""
        );

        const response =
          await api.post(
            `/paymentrzrrts/subscriptions/${customerSubscriptionId}/cancel`,
            {
              cancel_at_cycle_end:
                !cancelImmediately,
            }
          );

        if (
          response.data
            ?.success
        ) {
          setCancelDialogVisible(
            false
          );

          await fetchSubscription();
        }
      } catch (error) {
        console.error(
          "Subscription cancellation failed:",
          error.response
            ?.data ||
            error
        );

        setActionError(
          error.response
            ?.data
            ?.message ||
            "Failed to cancel the subscription."
        );
      } finally {
        setCancelLoading(
          false
        );
      }
    };

  // ============================================================
  // REFUND LOGIC TEMPORARILY DISABLED
  // ============================================================
  // const handleCancelAndRefund =
    // async () => {
      // const customerSubscriptionId =
        // subscription
          // ?.customer_subscription_id;
//
      // if (
        // !customerSubscriptionId ||
        // !showRefundButton
      // ) {
        // return;
      // }
//
      // try {
        // setRefundLoading(
          // true
        // );
//
        // setActionError(
          // ""
        // );
//
        // const response =
          // await api.post(
            // `/Subrefund/subscriptions/${customerSubscriptionId}/cancel-and-refund`
          // );
//
        // if (
          // response.data
            // ?.success
        // ) {
          // window.location.reload();
        // }
      // } catch (error) {
        // console.error(
          // "Cancel and refund failed:",
          // error.response
            // ?.data ||
            // error
        // );
//
        // setActionError(
          // error.response
            // ?.data
            // ?.message ||
            // "Failed to cancel the subscription and initiate the refund."
        // );
//
        // await fetchSubscription();
      // } finally {
        // setRefundLoading(
          // false
        // );
      // }
    // };
//
  // const confirmCancelAndRefund =
    // () => {
      // confirmDialog({
        // header:
          // "Cancel Subscription and Get Refund",
//
        // message:
          // "Your subscription will end immediately, your wallet balance will be reset to zero, and the eligible payment will be refunded. This action cannot be undone.",
//
        // acceptLabel:
          // "Cancel & Refund",
//
        // rejectLabel:
          // "Keep Subscription",
//
        // acceptClassName:
          // "p-button-danger",
//
        // className:
          // "cancel-dialog",
//
        // accept:
          // handleCancelAndRefund,
      // });
    // };

  const openCancellationDialog =
    () => {
      if (
        !canCancelSubscription
      ) {
        return;
      }

      setActionError(
        ""
      );

      setCancelDialogVisible(
        true
      );
    };

  const closeCancellationDialog =
    () => {
      if (
        cancelLoading
        // REFUND DISABLED:
        // || refundLoading
      ) {
        return;
      }

      setCancelDialogVisible(
        false
      );
    };

  const renderPrice = (
    highlightOffer = true
  ) => {
    if (
      hasOfferDiscount
    ) {
      return (
        <>
          <span
            style={{
              textDecoration:
                "line-through",
              opacity: 0.65,
              marginRight:
                "8px",
            }}
          >
            {
              formattedRegularAmount
            }
          </span>

          <span
            className={
              highlightOffer
                ? "text-pink"
                : undefined
            }
          >
            {
              formattedDisplayedAmount
            }
          </span>
        </>
      );
    }

    return (
      <span
        className={
          highlightOffer
            ? "text-pink"
            : undefined
        }
      >
        {
          formattedDisplayedAmount
        }
      </span>
    );
  };

  const renderStatusMessage =
    () => {
      if (
        cancellationScheduled
      ) {
        return (
          <>
            <strong>
              Cancellation
              scheduled
            </strong>

            <br />

            Your subscription
            remains active until{" "}

            <strong>
              {moment(
                subscription
                  ?.cancellation
                  ?.access_until ||
                  subscription
                    ?.end_date
              ).format(
                "DD MMM YYYY"
              )}
            </strong>
            .

            <br />

            You will not be
            charged again.
          </>
        );
      }

      switch (
        subscription?.status
      ) {
        case "ACTIVE":
          return (
            <>
              Your subscription
              is currently
              active.
            </>
          );

        case "PENDING":
          return (
            <>
              ⚠️ Payment update
              required. Your last
              auto-debit attempt
              failed.

              <br />

              Please update your
              payment method to
              avoid service
              interruption.
            </>
          );

        case "HALTED":
          return (
            <>
              ❌ Your subscription
              has been halted due
              to failed payment
              retries.

              <br />

              Please renew your
              subscription to
              restore access.
            </>
          );

        case "CANCELLED":
          return (
            <>
              🚫 Your subscription
              has been cancelled.
            </>
          );

        case "COMPLETED":
          return (
            <>
              🎉 Your subscription
              cycle has been
              completed
              successfully.

              <br />

              Buy again to renew
              your subscription.
            </>
          );

        case "EXPIRED":
          return (
            <>
              Your subscription
              has expired.
            </>
          );

        default:
          return null;
      }
    };

  return (
    <>
      {/* REFUND LOGIC TEMPORARILY DISABLED
      <ConfirmDialog className="alartDig" />
      */}

      <Row className="mx-0">
        <Col
          md={12}
          lg={12}
          xs={12}
          className="prof_title p-0 mb-lg-4 d-lg-flex justify-content-between align-items-center"
        >
          <h4>
            Subscriptions
          </h4>

          <div className="d-flex gap-2">
            <div className="d-lg-flex align-items-center gap-2">
              <p className="text-pink mb-0">
                {
                  autoRenewText
                }
              </p>

              <InputSwitch
                checked={
                  checked
                }
                disabled
              />
            </div>

            {subscription &&
              !cancellationScheduled &&
              (
                subscription.status ===
                  "PENDING" ||
                subscription.status ===
                  "HALTED"
              ) && (
                <Button
                  className="py-1 custbuttonpink"
                  label="Renew Now"
                  outlined
                  onClick={() => {
                    setRenewData(
                      subscription
                    );

                    setVisibleRight(
                      true
                    );
                  }}
                />
              )}
          </div>
        </Col>

        <Row className="mx-0 justify-content-between">
          <Col
            md={12}
            lg={5}
            xs={12}
            className="mt-4 packCard bg-transparent px-0"
          >
            <div className="leftsubs">
              <h4 className="mb-3">
                Plan

                {statusLabel && (
                  <span
                    className="ms-2 px-2 py-1"
                    style={{
                      fontSize:
                        "9px",
                      borderRadius:
                        "20px",
                      fontWeight:
                        400,
                      fontFamily:
                        "SFPro, serif",
                      letterSpacing:
                        "0.5px",
                      ...statusTheme,
                    }}
                  >
                    {
                      statusLabel
                    }
                  </span>
                )}
              </h4>

              {loading && (
                <p className="text-secondary">
                  Loading
                  subscription...
                </p>
              )}

              {!subscription &&
                !loading && (
                  <p className="text-secondary">
                    No subscription
                    found
                  </p>
                )}

              {subscription && (
                <>
                  <p>
                    <span>
                      {
                        plan
                          ?.sub_name
                      }{" "}
                      –{" "}

                      {renderPrice()}

                      {" / "}

                      {plan
                        ?.plan_type
                        ?.toLowerCase()}

                      <br />

                      {isWaitlistOffer && (
                        <small className="text-pink">
                          Permanent
                          waitlist offer
                          applied
                        </small>
                      )}

                      {!isWaitlistOffer && (
                        <small>
                          VAT or sales
                          tax may apply
                        </small>
                      )}
                    </span>
                  </p>

                  <p>
                    <b>
                      Plan Type:{" "}

                      {plan
                        ?.plan_type
                        ?.toLowerCase()}
                    </b>

                    {billingDate && (
                      <span className="d-block">
                        {
                          billingDateLabel
                        }
                        :{" "}

                        <small className="text-pink">
                          {moment(
                            billingDate
                          ).format(
                            "DD MMM YYYY"
                          )}
                        </small>
                      </span>
                    )}
                  </p>
                </>
              )}
            </div>

            <div>
              {subscription?.status && (
                <div
                  className="mb-3 resp_subs"
                  style={{
                    fontWeight:
                      400,
                    fontFamily:
                      "SFPro, serif",
                    letterSpacing:
                      "0.5px",
                    width:
                      "fit-content",
                    maxWidth:
                      "100%",
                    borderRadius:
                      "20px",
                    padding:
                      "12px 15px",
                    ...statusTheme,
                  }}
                >
                  {
                    renderStatusMessage()
                  }
                </div>
              )}

              {/* ======================================================
                  REFUND UI TEMPORARILY DISABLED

              {showRefundButton && (
                <div
                  className="mb-3"
                  style={{
                    width:
                      "100%",
                    maxWidth:
                      "520px",
                    padding:
                      "15px",
                    borderRadius:
                      "12px",
                    background:
                      "rgba(29, 107, 85, 0.18)",
                    border:
                      "1px solid #17E1A8",
                    color:
                      "#FFFFFF",
                  }}
                >
                  <h5 className="mb-2">
                    Eligible for a
                    refund
                  </h5>

                  <p
                    className="mb-2"
                    style={{
                      fontSize:
                        "13px",
                    }}
                  >
                    You are within
                    the first 15
                    days of the
                    subscription
                    and at least
                    50% of your
                    subscription
                    credits remain.
                  </p>

                  {refundDeadline && (
                    <small
                      className="d-block mb-2"
                      style={{
                        color:
                          "#C5C5C5",
                      }}
                    >
                      Refund
                      eligibility
                      ends on{" "}

                      <span className="text-pink">
                        {moment(
                          refundDeadline
                        ).format(
                          "DD MMM YYYY, hh:mm A"
                        )}
                      </span>
                      .
                    </small>
                  )}

                  {refundCredits
                    ?.plan_credits !=
                    null && (
                    <small
                      className="d-block mb-3"
                      style={{
                        color:
                          "#C5C5C5",
                      }}
                    >
                      Wallet balance:{" "}

                      <span className="text-white">
                        {
                          refundCredits
                            .wallet_balance
                        }
                      </span>

                      {" / "}

                      Plan credits:{" "}

                      <span className="text-white">
                        {
                          refundCredits
                            .plan_credits
                        }
                      </span>
                    </small>
                  )}

                  <Button
                    label="Cancel Now & Get Refund"
                    severity="danger"
                    loading={
                      refundLoading
                    }
                    disabled={
                      refundLoading ||
                      cancelLoading
                    }
                    onClick={
                      confirmCancelAndRefund
                    }
                  />
                </div>
              )}
              ====================================================== */}


              {actionError && (
                <div
                  className="mb-3"
                  style={{
                    width:
                      "100%",
                    maxWidth:
                      "520px",
                    padding:
                      "10px 12px",
                    borderRadius:
                      "8px",
                    color:
                      "#FFDAE1",
                    background:
                      "rgba(231, 36, 72, 0.15)",
                    border:
                      "1px solid #E72448",
                    fontSize:
                      "13px",
                  }}
                >
                  {
                    actionError
                  }
                </div>
              )}
            </div>
          </Col>

          <Col
            md={12}
            lg={6}
            xs={12}
            className="mt-4 packCard bg-transparent px-0"
          >
            <div className="rightsubs">
              <h4 className="mb-3">
                Credit
              </h4>

              {!subscription &&
                !loading && (
                  <p className="text-secondary">
                    No credits
                    available
                  </p>
                )}

              {subscription && (
                <div
                  style={{
                    width:
                      "100%",
                    maxWidth:
                      "420px",
                  }}
                >
                  <ProgressBar
                    value={
                      percentage
                    }
                    showValue={
                      false
                    }
                    style={{
                      height:
                        "6px",
                      borderRadius:
                        "10px",
                      background:
                        "#2D2C2C",
                    }}
                  />

                  <div className="flex justify-content-between mt-3 mb-2 text-sm">
                    <span className="text-white">
                      Balance

                      <small
                        style={{
                          color:
                            "#C5C5C5",
                          fontSize:
                            "13px",
                          fontWeight:
                            400,
                          letterSpacing:
                            "0.5px",
                          marginLeft:
                            "8px",
                          borderRadius:
                            "13px",
                          border:
                            "1px dashed #7C7C7C",
                          background:
                            "#111111",
                          padding:
                            "3px 8px",
                        }}
                      >
                        <PiCoinsDuotone className="text-pink" />{" "}

                        {
                          balance
                        }
                      </small>
                    </span>
                  </div>

                  <small
                    style={{
                      display:
                        "block",
                      fontSize:
                        "12px",
                      color:
                        "#C5C5C5",
                      margin:
                        "6px 0 15px 0",
                      letterSpacing:
                        "0.65px",
                    }}
                  >
                    {plan
                      ?.credits_per_month}{" "}
                    credits added{" "}

                    {plan
                      ?.plan_type
                      ?.toLowerCase()}
                  </small>
                </div>
              )}
            </div>

            <div className="dangerzonePart">
              {canCancelSubscription && (
                <Inplace closable>
                  <InplaceDisplay className="buttonpart">
                    Cancel a
                    subscription
                  </InplaceDisplay>

                  <InplaceContent className="dengerAcordian">
                    <p className="m-0">
                      You can cancel
                      your subscription
                      immediately or
                      schedule
                      cancellation for
                      the end of the
                      current billing
                      period.
                    </p>

                    <hr />

                    <p className="m-0">
                      Your active
                      subscription:
                    </p>

                    <div className="mt-3">
                      <div>
                        <h4 className="mb-0">
                          {plan
                            ?.sub_name}{" "}
                          –{" "}

                          <span className="text-pink">
                            {
                              renderPrice(
                                false
                              )
                            }

                            {" / "}

                            {plan
                              ?.plan_type
                              ?.toLowerCase()}
                          </span>
                        </h4>

                        {isWaitlistOffer && (
                          <small className="d-block mt-2 text-pink">
                            Your
                            permanent
                            offer price
                            will continue
                            on future
                            renewals.
                          </small>
                        )}

                        <p
                          className="mb-0 text-white"
                          style={{
                            fontSize:
                              "15px",
                            marginTop:
                              "8px",
                          }}
                        >
                          {
                            billingDateLabel
                          }
                          :{" "}

                          <span className="text-pink">
                            {moment(
                              billingDate
                            ).format(
                              "MMM Do, YYYY"
                            )}
                          </span>
                        </p>
                      </div>

                      <div className="d-flex gap-2 justify-content-end mt-5">
                        {canSwitchPlan && (
                          <Button
                            label="Switch plan"
                            className="switchplan"
                            onClick={() =>
                              navigate(
                                "/planupdate"
                              )
                            }
                          />
                        )}

                        <Button
                          label="Cancel subscription"
                          className="cancelplan"
                          onClick={
                            openCancellationDialog
                          }
                        />
                      </div>
                    </div>
                  </InplaceContent>
                </Inplace>
              )}

              {cancellationScheduled && (
                <div className="dengerAcordian">
                  <h5 className="mb-2">
                    Cancellation
                    already
                    scheduled
                  </h5>

                  <p className="mb-0 text-secondary">
                    Your subscription
                    will end on{" "}

                    <span className="text-pink">
                      {moment(
                        subscription
                          ?.cancellation
                          ?.access_until ||
                          subscription
                            ?.end_date
                      ).format(
                        "DD MMM YYYY"
                      )}
                    </span>
                    . You will not be
                    charged again and
                    no further
                    cancellation
                    action is
                    required.
                  </p>
                </div>
              )}

              {subscription &&
                TERMINAL_STATUSES.includes(
                  subscription.status
                ) && (
                  <div className="subEnddiv">
                    <h5 className="mb-2">
                      Subscription
                      ended
                    </h5>

                    <p className="mb-0 text-secondary">
                      This subscription
                      cannot be
                      cancelled again.
                    </p>

                    {/* REFUND MESSAGE TEMPORARILY DISABLED
                    <small className="mb-0 mt-2 text-danger d-block">
                      If a refund was
                      initiated, it
                      will normally be
                      processed within
                      5–7 business
                      days.
                    </small>
                    */}
                  </div>
                )}
            </div>
          </Col>
        </Row>
      </Row>

      <Sidebar
        className="shortCartSide"
        visible={
          visibleRight
        }
        position="right"
        onHide={() =>
          setVisibleRight(
            false
          )
        }
        style={{
          width:
            "500px",
        }}
      >
        <Renew
          data={
            renewData
          }
          onClose={() =>
            setVisibleRight(
              false
            )
          }
        />
      </Sidebar>

      <Dialog
        visible={
          cancelDialogVisible
        }
        style={{
          width:
            "430px",
          textAlign:
            "center",
        }}
        onHide={
          closeCancellationDialog
        }
        closable={
          !cancelLoading
          // REFUND DISABLED:
          // && !refundLoading
        }
        dismissableMask={
          !cancelLoading
          // REFUND DISABLED:
          // && !refundLoading
        }
        header={
          <div
            style={{
              textAlign:
                "center",
              color:
                "#D4D4D4",
              paddingTop:
                "10px",
            }}
          >
            Cancel
            Subscription
          </div>
        }
      >
        <p
          style={{
            fontSize:
              "14px",
            textAlign:
              "center",
            color:
              "#D4D4D4",
          }}
        >
          Choose how you
          want to cancel
          your subscription.
        </p>

        {actionError && (
          <div
            className="mb-3"
            style={{
              padding:
                "10px 12px",
              borderRadius:
                "8px",
              background:
                "rgba(231, 36, 72, 0.15)",
              border:
                "1px solid #E72448",
              color:
                "#FFDAE1",
              fontSize:
                "13px",
            }}
          >
            {
              actionError
            }
          </div>
        )}

        <div className="d-flex flex-column gap-3 mt-3">
          <Button
            label="Cancel Immediately"
            severity="danger"
            outlined
            loading={
              cancelLoading
            }
            disabled={
              cancelLoading
            }
            onClick={() =>
              handleCancelSubscription(
                true
              )
            }
          />

          <Button
            label="Cancel at End of Billing Cycle"
            severity="warning"
            outlined
            loading={
              cancelLoading
            }
            disabled={
              cancelLoading
            }
            onClick={() =>
              handleCancelSubscription(
                false
              )
            }
          />
        </div>

        <p
          className="mt-3"
          style={{
            fontSize:
              "12px",
            textAlign:
              "center",
            color:
              "#D4D4D4",
          }}
        >
          <em>
            Immediate
            cancellation stops
            access instantly.
            End-of-cycle
            cancellation allows
            usage until{" "}

            <b>
              {moment(
                subscription
                  ?.end_date ||
                  subscription
                    ?.renewal_date
              ).format(
                "DD MMM YYYY"
              )}
            </b>
            .
          </em>
        </p>
      </Dialog>
    </>
  );
};

export default Subscriptions;